export class MobileNav {
  constructor() {
    // Class properties
    this.navActiveClass = 'nav-active';
    this.navCloseClass = 'nav-close';
    this.hasDropClass = 'hasdrop';
    this.hasDropAClass = 'hasdrop-a';

    // Cache DOM elements
    this.body = document.body;
    this.navOpener = document.querySelector('.nav-opener');
    this.navSlide = document.querySelector('.nav-slide');
    this.links = this.navSlide?.querySelectorAll('a') || [];
    this.mainNavItems = document.querySelectorAll('.main-nav li');

    // Bind methods to preserve context
    this.handleNavClick = this.handleNavClick.bind(this);
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.updateNavHeight = this.updateNavHeight.bind(this);

    this.init();
  }

  init() {
    this.addEventListeners();
    this.addArrowIcons();
    this.setupDropdowns();
    this.updateNavHeight();
  }

  addEventListeners() {
    // Use event delegation for nav opener clicks
    document.body.addEventListener('click', (e) => {
      if (e.target.closest('.nav-opener')) {
        e.preventDefault();
        this.handleNavClick(e);
      }
    });

    // Link click events
    this.links.forEach(link => {
      link.addEventListener('click', this.handleLinkClick);
    });

    // Resize event for nav height
    window.addEventListener('resize', this.updateNavHeight);
  }

  handleNavClick() {
    // Toggle both the nav-active class on body and close class on the opener
    this.body.classList.toggle(this.navActiveClass);
    this.navOpener.classList.toggle('close');

    // Handle close animation when closing
    if (!this.body.classList.contains(this.navActiveClass)) {
      this.body.classList.add(this.navCloseClass);
      setTimeout(() => {
        this.body.classList.remove(this.navCloseClass);
      }, 1001);
    }
  }

  handleLinkClick(event) {
    const link = event.currentTarget;
    if (!link.classList.contains(this.hasDropAClass)) {
      this.body.classList.remove(this.navActiveClass);
    }
  }

  addArrowIcons() {
    const menuItems = document.querySelectorAll('.main-nav li > a');
    menuItems.forEach(item => {
      if (!item.querySelector('.arrow-right')) {
        const arrow = document.createElement('i');
        arrow.className = 'arrow-right';
        item.appendChild(arrow);
      }
    });
  }

  setupDropdowns() {
    this.mainNavItems.forEach((item, index) => {
      // Set index for CSS animation timing
      item.style.setProperty('--index', index);

      const dropdownMenu = item.querySelector('ul');
      const firstLink = item.querySelector('a');

      if (dropdownMenu && firstLink) {
        // Add dropdown classes
        item.classList.add(this.hasDropClass);
        firstLink.classList.add(this.hasDropAClass);

        // Add data attributes
        firstLink.setAttribute('data-more', '');
        firstLink.setAttribute('data-outside', '');
      }
    });
  }

  updateNavHeight() {
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    this.navSlide?.style.setProperty('height', `${windowHeight}px`);
  }

  dispose() {
    // Remove event listeners
    window.removeEventListener('resize', this.updateNavHeight);

    // Clean up references
    this.body = null;
    this.navOpener = null;
    this.navSlide = null;
    this.links = null;
    this.mainNavItems = null;
  }
}
